export class SliderSlideNav {
  position = 'no-position';
  onlyOnHover = '';
  largerStyle = '';
  margin = '';
  breakpoint = 'uk-visible@s';
  color = 'uk-dark';
}
